import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './CallToAction.css';
import AppointmentModal from '../AppointmentModal/AppointmentModal'; // Import the new modal component

const CallToAction = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <section className="call-to-action-final py-5 text-white text-center">
      <div className="container">
        <h2 className="display-4 fw-bold mb-4">¿Listo para llevar tu negocio al siguiente nivel?</h2>
        <Button variant="light" size="lg" onClick={handleShow}>Agenda tu cita</Button>
      </div>
      <AppointmentModal show={showModal} handleClose={handleClose} />
    </section>
  );
};

export default CallToAction;
